import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "scoringOverview";

export const useScoringOverviewStore = defineStore(storeName, () => {
  const all = ref([]);
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("risk-scoring-overview", errorCallback);
  };

  const countForRiskLevel = (level) => {
    let risk_level = all.value.filter((item) => item.name === level);
    if(risk_level.length > 0)
      return risk_level[0].value;
    else return 0;
  };

  const watchResourceChanges = async (callback) => {
    await watchRemoteResourceChange("company", callback);
    await watchRemoteResourceChange("physicalPerson", callback);
  };

  return {
    overview: all,
    fetchRiskOverview: fetchAll,
    countForRiskLevel,
    watchResourceChanges
  };
});
